global.showServerError = function () {
    bootbox.alert('Le serveur a retourné une erreur. Veuillez essayer plus tard.');
};